import script from "./TemplateVariablePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./TemplateVariablePicker.vue?vue&type=script&lang=ts&setup=true"

import "./TemplateVariablePicker.vue?vue&type=style&index=0&id=10bc72ba&scoped=true&lang=css"
import "./TemplateVariablePicker.vue?vue&type=style&index=1&id=10bc72ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10bc72ba"]])

export default __exports__